var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30633 6.60473C7.11019 6.45222 6.82657 6.46608 6.64633 6.64632C6.45106 6.84158 6.45106 7.15817 6.64633 7.35343L11.2928 11.9998L6.64633 16.6463L6.60473 16.6934C6.45222 16.8895 6.46608 17.1731 6.64633 17.3534C6.84159 17.5486 7.15817 17.5486 7.35344 17.3534L11.9999 12.7069L16.6464 17.3534L16.6935 17.395C16.8896 17.5475 17.1732 17.5336 17.3535 17.3534C17.5488 17.1581 17.5488 16.8415 17.3535 16.6463L12.707 11.9998L17.3535 7.35343L17.3951 7.30632C17.5476 7.11018 17.5337 6.82656 17.3535 6.64632C17.1582 6.45106 16.8416 6.45106 16.6464 6.64632L11.9999 11.2927L7.35344 6.64632L7.30633 6.60473Z",
    fill: "#131415"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseNotification);
export default __webpack_public_path__ + "static/media/icon-close-notification.6160c2645bf6b93423ce2b321877fe24.svg";
export { ForwardRef as ReactComponent };